import { encaisseDuJour, jourBamako } from '../api/encaissement'
import type { DonneesOps } from '../api/types'
import { estAujourdHui, fcfa } from './Format'
import { Icone, type NomIcone } from './Icone'

/**
 * La bande d'indicateurs — TRANSPOSITION de `renderKPIs()`.
 *
 * ⚠️ « Encaissé aujourd'hui » = les paiements ENREGISTRÉS aujourd'hui : encaissements de courses (espèces, Wave,
 * Orange Money, autre) et règlements de factures. C'est la définition de la comptabilité (la trésorerie
 * n'apparaît qu'à un paiement enregistré). Avant le lot 2 il additionnait le prix des courses livrées du jour —
 * de la facturation, pas de l'argent reçu — y compris celles des PME, que la compta ne comptait pas.
 *
 * La valeur vient de la base (`encaisse_du_jour`, qui voit aussi les règlements de factures que le dispatch n'a pas
 * le droit de lire) ; à défaut, elle est recalculée ici à partir des paiements chargés.
 */
export function Kpis({ donnees }: { donnees: DonneesOps }) {
  const dujour = donnees.courses.filter((c) => estAujourdHui(c.created_at))
  const actives = donnees.courses.filter((c) => ['creee', 'assignee', 'collecte', 'en_livraison'].includes(c.statut))
  const livrees = donnees.courses.filter((c) => c.statut === 'livree' && estAujourdHui(c.delivered_at))
  const encaisse = donnees.encaisseJour ?? encaisseDuJour(donnees, jourBamako()).total

  const indicateurs: { libelle: string; valeur: string; icone: NomIcone; aide?: string }[] = [
    { libelle: "Demandes aujourd'hui", valeur: String(dujour.length), icone: 'clock' },
    { libelle: 'Courses en cours', valeur: String(actives.length), icone: 'package' },
    { libelle: "Livrées aujourd'hui", valeur: String(livrees.length), icone: 'check' },
    {
      libelle: "Encaissé aujourd'hui",
      valeur: fcfa(encaisse),
      icone: 'wallet',
      aide: 'Paiements enregistrés aujourd’hui (courses de particuliers et règlements de factures). Une livraison non encaissée n’y figure pas.',
    },
    { libelle: 'Clients actifs', valeur: String(donnees.clients.filter((c) => c.status === 'active').length), icone: 'users' },
  ]

  return (
    <div className="kpis" id="kpi-row">
      {indicateurs.map((k) => (
        <div className="kpi" data-anim key={k.libelle} title={k.aide}>
          <div className="kpi-ic">
            <Icone nom={k.icone} />
          </div>
          <div className="kpi-label">{k.libelle}</div>
          <div className="kpi-val">{k.valeur}</div>
        </div>
      ))}
    </div>
  )
}
